export enum ActionRequiredTypeEnum {
    ORDER_SUBMITTED_AND_TUBES_ALREADY_RECEIVED = 1,
    ORDER_RECEIVED_AND_TUBES_NOT_RECEIVED = 2,
    ORDER_COMPLETED_AND_REACTIONS_NOT_COMPLETED = 5,
    ORDER_CONTAINS_COMPLETED_REACTIONS_WITHOUT_RESULT = 8,
    ORDER_REQUIRES_NEW_TUBES = 10,
}
